// Mockup §12: unequal, overlapping mural. Rails owns the img tags; this only
// tags them so CSS can break the rhythm. The first still stays full width.
export function enhanceGallery(root = document) {
  root.querySelectorAll(".mural-item").forEach((item, index) => {
    if (index === 0) return
    item.classList.add(index % 2 === 1 ? "mural-wide" : "mural-tall")
  })
}

export function GalleryRoot() {
  enhanceGallery(document)
  return null
}
